import { useAppSelector } from '../../global/hooks';
import {
	selectActiveSectionId,
	selectActiveSectionRepeatIndex,
	selectMode,
	selectTimeSignature
} from '../../store/appSlice';
import { Section } from '../../types';
import { get1BeatDurationInSeconds } from '../../utils/timing';
import { StyledProgressLine } from './styles';

interface Props {
	section: Section;
}
export default function ProgressLine({ section }: Props) {
	const isPlaying = useAppSelector(selectMode) === 'play';
	const isSectionActive = useAppSelector(selectActiveSectionId) === section.id;
	const sectionRepeatIndex = useAppSelector(selectActiveSectionRepeatIndex);
	const timeSignature = useAppSelector(selectTimeSignature);

	// get total bars in section
	const sectionChordCount = section.chords.reduce((acc, chord) => acc + chord.length, 0);

	// progress
	const total = section.repeatCount * sectionChordCount;
	const current = (sectionRepeatIndex + 1) * sectionChordCount;
	const progress = (current / total) * 100;

	// 1 section run through = total chords * 1 beat in s
	const oneBeatInSeconds = get1BeatDurationInSeconds(timeSignature);
	const sectionLengthInSeconds = sectionChordCount * oneBeatInSeconds * timeSignature[0];
	return (
		<StyledProgressLine
			active={isSectionActive && isPlaying}
			progress={progress}
			sectionLengthInSeconds={sectionLengthInSeconds}
		/>
	);
}
